import * as actions from './rfr-save.actions';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { SpxToasterAutoCloseSpeedEnum, spxToasterActions } from '@softpak/components/spx-toaster';
import { catchError, map, mergeMap, withLatestFrom } from 'rxjs/operators';

import { ApiRfrMethod } from 'src/app/api/api-methods.rfr';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { RfrSaveI } from 'src/app/api/rfr-save/rfr-save.result.int';
import { SharedErrorObjectI } from 'src/app/shared/models/shared/shared-error-object.interface';
import { SharedGenericService } from 'src/app/shared/services/shared-generic.service';
import { Store } from '@ngrx/store';
import { loadingRfrSave } from 'src/app/shared/_config/i18n/i18n-interface';
import { rfrSaveReducer } from '.';
import { spxSpinnerActions } from '@softpak/components/spx-spinner';

@Injectable()
export class RfrSaveEffects {
    private readonly appStore = inject(Store);
    private readonly actions$ = inject(Actions);
    private readonly sharedGenericService = inject(SharedGenericService);

  

    load$ = createEffect(() =>
        this.actions$.pipe(ofType(actions.load),
            mergeMap((params) => this.sharedGenericService.invoke(ApiRfrMethod.rfrSave, params.query).pipe(
                map((data: RfrSaveI) => actions.received({
                    data
                })),
                catchError((error: SharedErrorObjectI) => [
                    actions.error({
                        messageText: error.message
                    }),
                ])
            ))
        ));

    onError$: Observable<any> = createEffect(() => this.actions$.pipe(
        ofType(actions.error),
        mergeMap(action => [
            spxToasterActions.createError({
                autoClose: SpxToasterAutoCloseSpeedEnum.DEFAULT,
                messageText: action.messageText,
            }),
        ]))
    );

    afterReceived$: Observable<any> = createEffect(() => this.actions$.pipe(
        ofType(actions.received),
        withLatestFrom(this.appStore.select(rfrSaveReducer.default.selectQuery)),
        mergeMap((query) => [
            spxSpinnerActions.hide({
                action: loadingRfrSave
            }),
            spxToasterActions.createSuccess({
                messageText: `Update reefer settings ${query[1].containerPrefix}${query[1].containerNumber} `,
                autoClose: SpxToasterAutoCloseSpeedEnum.SLOW,
            }),
        ]))
    );

    afterLoad$: Observable<any> = createEffect(() => this.actions$.pipe(
        ofType(actions.load),
        mergeMap(() => [
            spxSpinnerActions.show({
                action: loadingRfrSave
            }),
        ]))
    );

    afterError$: Observable<any> = createEffect(() => this.actions$.pipe(
        ofType(actions.error),
        mergeMap(() => [
            spxSpinnerActions.hide({
                action: loadingRfrSave
            }),
        ]))
    );
}
